import { Injectable } from '@angular/core';
import { ID } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { CitizenReport } from '../../model/citizen-report';
import { UrlConfig } from '../../model/urlconfig';
import { HttpOptions, UpdateActionType } from '../../service/generic-akita-http.service';
import { WebsocketService } from '../../service/websocket.service';
import { encodeFiwareString } from '../../shared/replacer-util';
import { CitizenReportState, CitizenReportStore } from '../state/citizen-report.store';
import { AkitaCitizenReportHttpService } from './akita-http-citizen-report.service.';


@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class CitizenReportService extends NgEntityService<CitizenReportState> implements UrlConfig{

  constructor(
    protected store: CitizenReportStore,
    private citizenReportHttpService: AkitaCitizenReportHttpService,
    private webSocketService: WebsocketService,
  ) {
    super(store);

    this.webSocketService.getDataStream('CitizenReport')
      .pipe(untilDestroyed(this))
      .subscribe((data: CitizenReport[]) => this.store.upsertMany(data));
  }
  updateEntitiesUrl(newUrl: string): void {
    this.citizenReportHttpService.setEntitiesUrl(newUrl);
  }

  getAll() {
    this.citizenReportHttpService.getAll().subscribe(citizenReport => this.store.add(citizenReport));
  }

  getById(id: ID) {
    this.citizenReportHttpService.loadById(id).subscribe(citizenReport => this.store.add(citizenReport));
  }

  addCitizenReport(report: CitizenReport) {
    this.store.add(report);
    this.addReportToFiware(report);
  }

  private addReportToFiware(report: CitizenReport) {
    const options: HttpOptions = {
      params: {
        options: 'keyValues'
      }
    };
    delete report.attachments; // we do an append in Fiware, so we don't need to reinsert them

    const encodedText = encodeFiwareString(report.answer?.text);
    report.answer.text = encodedText;

    this.citizenReportHttpService
      .update(report, UpdateActionType.APPEND, options)
      .subscribe(data => console.log('updated citizen report', data));
  }

}
